import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55643cd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "model-content" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#ccc"}
}
const _hoisted_3 = { key: 1 }

import {reactive, UnwrapRef,} from "vue";
import {getListDentist, saveBoundings} from "@/api/designer";
interface Data {
    showBindModal: boolean,
    loading: boolean,
    treeData: any[],
    checkedKeys: string[],
    total: number,
    fieldNames: {
        title: string,
        children: string,
        key: string,
    },
    dentistName?: string,
    "page": {
        "currPage": number,
        "pageSize": number
    },
}


export default /*#__PURE__*/_defineComponent({
  __name: 'bindModal',
  props: {
    id: {
        type: String,
        default: ''
    },
    type: {
        type: String,
        default: '',
    },
    bindTitle: {
        type: String,
        default: '设计师绑定团队',
    }
},
  setup(__props, { expose }) {

const prop = __props;



const data: UnwrapRef<Data> = reactive({
    showBindModal: false,
    loading: false,
    treeData: [],
    checkedKeys: [],
    total: 0,
    fieldNames: {
        title: 'name',
        children: 'child',
        key: 'id',
    },
    dentistName: '',
    "page": {
        "currPage": 1,
        "pageSize": 10
    },
})
const changePage = (page: number, pageSize: number) => {
    data.page.currPage = page
    data.page.pageSize = pageSize
    onSearch()
}

const loopData = (data: any[], arr: any[]) => {
    data.forEach(item => {
        if (item.hasChecked) {
            arr.push(item.id)
        }
        if (item.child && item.child.length) {
            loopData(item.child, arr)
        }
    })
}

const onSearch = async (type?:string) => {
    data.page.currPage=type?1:data.page.currPage
    data.loading = true
    try {
        let res = await getListDentist({
            dentistName: data.dentistName,
            page: data.page,
            groupId: prop.id,
            type: prop.type
        })
        data.loading = false
        data.treeData = res.data
        data.total = res.records
        let ids = []
        loopData(data.treeData, ids)
        data.checkedKeys = ids
    } catch (error) {
        data.loading = false
    }

}
const checkTree = async (checkedKeys, e) => {
    data.loading = true
    let {checked, checkedNodes, node} = e
    let type = ''
    let chooseNodes = []
    if (checked) {
        type = '1'
        if (node.child && node.child.length) {
            chooseNodes = node.child.filter(e=>!e.disableCheckbox)
        } else {
            chooseNodes = [node.dataRef
            ]
        }
    } else {
        type = '2'
        if (node.child && node.child.length) {
            chooseNodes = node.child.filter(e=>!e.disableCheckbox)
        } else {
            chooseNodes = [node.dataRef
            ]
        }

    }
    try {
        await saveBoundings(chooseNodes, type)
        data.loading = false
    } catch (error) {
        data.loading = false
    }

}
expose({onSearch, data})


return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (data.showBindModal)
    ? (_openBlock(), _createBlock(_component_a_modal, {
        key: 0,
        visible: data.showBindModal,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((data.showBindModal) = $event)),
        title: __props.bindTitle
      }, {
        footer: _withCtx(() => []),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (data.loading)
              ? (_openBlock(), _createBlock(_component_a_spin, {
                  key: 0,
                  class: "loading-area"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_row, { gutter: 10 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 14 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: data.dentistName,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data.dentistName) = $event)),
                          placeholder: "医生名字",
                          "allow-clear": ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (onSearch('init')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查询")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (data.treeData)
              ? (_openBlock(), _createBlock(_component_a_tree, {
                  key: 1,
                  onCheck: checkTree,
                  checkedKeys: data.checkedKeys,
                  "onUpdate:checkedKeys": _cache[2] || (_cache[2] = ($event: any) => ((data.checkedKeys) = $event)),
                  checkable: "",
                  "tree-data": data.treeData,
                  fieldNames: data.fieldNames
                }, {
                  title: _withCtx(( node ) => [
                    _createElementVNode("div", null, [
                      (node.boundingName&&!node.hasChecked)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(node.name) + "        已被绑定： " + _toDisplayString(node.boundingName), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(node.name), 1))
                    ])
                  ]),
                  _: 1
                }, 8, ["checkedKeys", "tree-data", "fieldNames"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_pagination, {
              style: {"text-align":"right","margin-top":"10px"},
              onChange: changePage,
              current: data.page.currPage,
              "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => ((data.page.currPage) = $event)),
              total: data.total,
              "show-less-items": ""
            }, null, 8, ["current", "total"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"]))
    : _createCommentVNode("", true)
}
}

})